import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageTitle: {
    id: "funding-application: additional funding page title",
    defaultMessage: "Apply for funding",
  },
  additionalFundingHelpText: {
    id: "funding-application: additional funding help text",
    defaultMessage:
      "Please ensure all of your platforms are connected and up to date using the <x>Connections</x> tab.",
  },
  submitButton: {
    id: "funding-application: additional funding submit button",
    defaultMessage: "Submit",
  },
  cancelButton: {
    id: "funding-application: additional funding cancel button",
    defaultMessage: "Cancel",
  },
});
